import { defineBvaiConfig } from '@bvai/config/config';

export const bvaiConfig: BvaiConfig = {
  agent: {
    actions: [
      'assign_conversation',
      'handover_to_ai_voice_agent',
      'start_workflow',
      'close_conversation',
      'add_private_note',
      'update_contact_attribute',
      'update_contact_tags',
    ],
  },
};

export function initBvai(): void {
  defineBvaiConfig(bvaiConfig);
}
